import styled from "styled-components";
import { Box, MenuItem, Select, TableCell } from "@material-ui/core";
import { primary } from "../../shared/Style/Style";
import { SearchBarInput } from "../../Schools/SearchBar/SearchBar.style";

export const FiltersBar = styled(Box)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin: 24px 0;
`;

// Multi-select with checkboxes, same look as the BundlesStorage filters.
export const LmsSelect = styled(Select).attrs({
  MenuProps: {
    getContentAnchorEl: null,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    PaperProps: {
      style: {
        maxHeight: 240,
        overflowY: "auto",
      },
    },
  },
})`
  width: 260px;
  height: 36px;
  background-color: white;

  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${primary};
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 2px solid ${primary} !important;
  }
  & .MuiSelect-select {
    font-size: 13px;
    font-weight: 600;
    background-color: white;
  }
  & .MuiSelect-icon {
    color: ${primary};
  }
`;

export const LmsMenuItem = styled(MenuItem)`
  padding: 2px 8px;

  &.Mui-selected,
  &.Mui-selected:hover,
  &.Mui-focusVisible {
    background-color: white !important;
  }
  & .MuiListItemText-primary {
    font-size: 13px;
  }
  & .MuiCheckbox-root {
    color: ${primary};
    padding: 2px;
  }
  & .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${primary};
  }
`;

export const SchoolNameCell = styled(TableCell)`
  cursor: pointer;
  color: ${primary};
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

// Wide enough for the whole label on one line (the shared 300px input wraps it).
export const ReportSearchInput = styled(SearchBarInput)`
  & .MuiInput-root {
    min-width: 420px;
  }
`;

export const ReportSummary = styled(Box)`
  display: flex;
  gap: 32px;
  margin-bottom: 12px;
  font-size: 14px;
`;
